const Promise = require('es6-promise').Promise;
const ToggleAnime = require('../velocity/toggle-anime');

/**
 * DropdownMenu
 * @class
 */
class DropdownMenu {

  /**
   * @static
   * @return {object} default options
   */
  static get defOpts() {
    return {
      selectors: {
        btn    : 'js-dropdown-menu-btn',
        close  : 'js-dropdown-menu-close',
        overlay: 'js-menu-dropdown-overlay',
      },
      breakPoint: 767,
    }
  };

  /**
   * @instance
   * @param el {string|HTMLElement} element
   * @param opts {object} options
   */
  constructor(el, opts = {}) {
    const { selectors, breakPoint } = _.defaults(opts, DropdownMenu.defOpts);

    this.el        = el;
    this.btnEl     = this.el.getElementsByClassName(selectors.btn);
    this.closeEl   = this.el.getElementsByClassName(selectors.close);
    this.overlayEl = document.getElementsByClassName(selectors.overlay);

    this.breakPoint = breakPoint;
    this.isBreak    = true;
    this.openCntEl  = null;
    this.isAnimate  = false;

    this.createAnime();

    this.handleEvents = {
      toggleMenu: {
        handleEvent: (e) => {
          this.toggleMenu(e);
        },
      },
      closeMenu: {
        handleEvent: () => {
          this.closeMenu();
        },
      },
    };

    window.addEventListener('load', this.setEvent.bind(this), false);
    window.addEventListener('resize', this.setEvent.bind(this), false);
  }

  /**
   * @instance
   * @private
   */
  createAnime() {
    this.toggleOverlay = new ToggleAnime({
      $el  : this.overlayEl,
      anime: [ 'fadeIn', 'fadeOut' ],
      opts : {
        duration: 300,
        easing  : 'linear',
      },
    });
  }

  /**
   * @instance
   * @private
   */
  setEvent() {
    if(this.breakPoint < window.innerWidth) {
      if(!this.isBreak) return;
      this.isBreak = false;

      _.forEach(this.btnEl, (el) => {
        el.addEventListener('click', this.handleEvents.toggleMenu, false);
      });
      _.forEach(this.closeEl, (el) => {
        el.addEventListener('click', this.handleEvents.closeMenu, false);
      });
      this.overlayEl[0].addEventListener('click', this.handleEvents.closeMenu, false)
    }
    else {
      if(this.isBreak) return;
      this.isBreak = true;

      if(this.openCntEl) {
        this.openCntEl.style.display = 'none';
        this.openCntEl = null;
      }

      _.forEach(this.btnEl, (el) => {
        el.removeEventListener('click', this.handleEvents.toggleMenu, false);
      });
      _.forEach(this.closeEl, (el) => {
        el.removeEventListener('click', this.handleEvents.closeMenu, false);
      });
      this.overlayEl[0].removeEventListener('click', this.handleEvents.closeMenu, false)
    }
  }

  /**
   * @instance
   * @private
   */
  toggleMenu(e) {
    e.preventDefault();
    if(this.isAnimate) return;
    this.isAnimate = true;

    const cntEl = e.target.nextElementSibling;

    if(cntEl.style.display !== 'block') {
      Promise.resolve()
      .then( () => {
        return new Promise( (resolve) => {
          if(this.openCntEl) {
            Velocity(this.openCntEl, 'fadeOut', {
              duration: 150,
              easing  : 'linear',
              complete: function() {
                this[0].style.opacity = 1;
                resolve();
              },
            });
          } else {
            resolve();
          }
        });
      })
      .then( () => {
        return new Promise( (resolve) => {
          if(this.overlayEl[0].style.display !== 'block') {
            this.toggleOverlay.run(true);
          }
          Velocity(cntEl, 'slideDown', {
            duration: 300,
            easing  : 'easeOutCubic',
            complete: () => {
              resolve();
            },
          });
        });
      })
      .then( () => {
        this.openCntEl = cntEl;
        this.isAnimate = false;
      });
    } else {
      this.close( () => {
        this.openCntEl = null;
        this.isAnimate = false;
      });
    }
  }

  /**
   * @instance
   * @private
   */
  closeMenu() {
    if(this.isAnimate) return;
    this.isAnimate = true;

    this.close( () => {
      this.openCntEl = null;
      this.isAnimate = false;
    });
  }

  /**
   * @instance
   * @private
   */
  close(cb) {
    this.toggleOverlay.run(false);
    Velocity(this.openCntEl, 'slideUp', {
      duration: 300,
      easing  : 'easeOutCubic',
      complete: () => cb(),
    });
  }

}

/**
 * class exports
 */
module.exports = DropdownMenu;



/** WEBPACK FOOTER **
 ** ./webpack/requires/view/ui/dropdown-menu.js
 **/